import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Elements
import FeatureSection3 from "../elements/feature-section3";
import TeamSection from "../elements/team";
import LatestNewsSection from "../elements/latest-news-slider";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import icon6 from "../../images/services/icon6.png";
import icon7 from "../../images/services/icon7.png";
import icon9 from "../../images/services/icon17.png";
import icon8 from "../../images/services/icon8.png";
import icon10 from "../../images/services/icon9.png";
import icon11 from "../../images/services/icon4.png";
import icon12 from "../../images/services/icon12.png";
import icon13 from "../../images/services/icon13.png";
import icon14 from "../../images/services/icon14.png";
import icon15 from "../../images/services/icon5.png";
// icon 16 = <a href="https://www.flaticon.com/free-icons/dental-implant" title="dental implant icons">Dental implant icons created by Victoruler - Flaticon</a>
import icon16 from "../../images/services/icon15.png";
// icon 17 = <a href="https://www.flaticon.com/free-icons/dental-crown" title="dental crown icons">Dental crown icons created by Culmbio - Flaticon</a>
import icon17 from "../../images/services/icon3.png"
import Offers from '../elements/offers';

class Services extends Component {

    render() {
        // Inline styles for centering the icons
        const iconCellStyle = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '85px',  // Adjust as needed
            height: '85px', // Adjust as needed
			margin: '10px',
        };

        return (
            <>
                <div className="page-content bg-white">
                    <div className="banner-wraper">
                        <div className="page-banner" style={{ backgroundImage: "url(" + bnrImg1 + ")" }}>
                            <div className="container">
                                <div className="page-banner-entry text-center">
                                    <h1>Services</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="section-area section-sp1">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature1">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon6} alt="Routine Dental Cleanings" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Routine Dental Cleanings and Examinations</h3>
                                            <p>Regular check-ups and cleanings are essential for maintaining good oral health. During these appointments, the dentist or dental hygienist will clean your teeth, remove plaque and tartar, and check for any signs of dental issues.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature2">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon7} alt="Dental X-rays" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Dental X-rays</h3>
                                            <p>X-rays are used to capture images of the teeth and bones in the jaw. They help dentists identify problems such as cavities, impacted teeth, and bone loss that may not be visible during a regular examination.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature3">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon8} alt="Fillings" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Fillings</h3>
                                            <p>If you have a cavity or tooth decay, the dentist may need to remove the damaged portion of the tooth and fill the space with a dental filling. Fillings are commonly made of materials like composite resin, amalgam, or ceramic.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature2">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon9} alt="Dental Crowns" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Dental Crowns</h3>
                                            <p>Dental crowns are used to cover and protect damaged or weakened teeth. They can restore the shape, size, and strength of a tooth, especially after procedures like root canals or if a tooth is significantly decayed.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature3">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon10} alt="Tooth Extractions" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Tooth Extractions</h3>
                                            <p>In cases where a tooth is severely damaged or impacted, extraction may be necessary. Dentists perform extractions to remove problematic teeth, making room for necessary dental procedures or to alleviate pain and prevent further complications.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature1">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon11} alt="Orthodontic Services" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Orthodontic Services</h3>
                                            <p>Orthodontic treatments focus on the alignment of teeth and jaws. This includes the use of braces, retainers, and other orthodontic devices to correct issues such as misaligned teeth, overbites, or underbites.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature1">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon12} alt="Root Canal" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Root Canal</h3>
                                            <p>This procedure is performed when the pulp of a tooth becomes infected or inflamed. During a root canal, the dentist removes the damaged pulp, cleans the inside of the tooth, and seals it to prevent further infection. It is typically followed by placing a crown to restore the tooth’s strength.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature1">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon13} alt="Dental Bridges" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Dental Bridges</h3>
                                            <p>Dental bridges are used to replace one or more missing teeth by anchoring a false tooth (or teeth) to the surrounding natural teeth or implants. The bridge fills the gap where teeth are missing, restoring your smile and improving chewing and speaking. Unlike implants, bridges do not require surgery and can be a more affordable option for tooth replacement.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature1">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon14} alt="Teeth Whitening" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Teeth Whitening</h3>
                                            <p>Teeth whitening is a cosmetic procedure that removes stains and discoloration from teeth. It can be done in-office using stronger bleaching agents or through take-home kits provided by the dentist. Whitening improves the appearance of teeth but does not affect their structure.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature1">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon16} alt="Teeth Whitening" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Dentures</h3>
                                            <p>Dentures are removable prosthetic devices designed to replace missing teeth, providing support for the lips and cheeks and restoring a natural appearance. They can be made of acrylic, metal, or a combination and are custom-fitted to ensure comfort. Dentures do not prevent further tooth loss but help improve chewing, speech, and aesthetics.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature1">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon17} alt="Teeth Whitening" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Implants</h3>
                                            <p>Dental implants are metal posts surgically positioned into the jawbone beneath the gums to act as roots for replacement teeth. Implants provide a stable foundation for fixed or removable replacement teeth that look and function like natural teeth. They require adequate bone support and contribute to jawbone health but do not alter surrounding teeth.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="feature-container feature-bx2 feature1">
                                        <div className="feature-box-xl mb-20">
                                            <span className="icon-cell" style={iconCellStyle}>
                                                <img src={icon15} alt="Teeth Whitening" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="ttr-title">Periodontic</h3>
                                            <p>Periodontics is a branch of dentistry focusing on the prevention, diagnosis, and treatment of periodontal disease, which affects the gums and supporting structures of the teeth. Periodontic treatments range from deep cleanings to surgical interventions that improve gum health, but they do not replace missing teeth.</p>
                                            <Link to="/service-detail" className="btn btn-primary light">View More</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </section>

                    <FeatureSection3 />
                    <TeamSection />
                    <Offers/>
                    <LatestNewsSection />
                </div>
            </>
        );
    }
}

export default Services;
